import React, { lazy } from 'react'

import Routes from 'components/Routes'
import SuspenseWithErrorBoundary from 'generics/SuspenseWithErrorBoundary'

import SessionRestore from './SessionRestore'

const ConsentBanner = lazy(() => import('generics/ConsentBanner/ConsentBanner'))

/**
 * App routes and deferred consent UI. MUI theme providers stay eager in Application.js
 * so layout chrome has theme context on first paint.
 */
const MuiProviders = () => (
  <>
    <SessionRestore>
      <Routes />
    </SessionRestore>
    <SuspenseWithErrorBoundary fallback={null}>
      <ConsentBanner />
    </SuspenseWithErrorBoundary>
  </>
)

export default MuiProviders
